import React, { useState, useEffect, useContext } from "react";
import { Redirect } from "react-router";
import mixpanel from "mixpanel-browser";

import { auth, getUser } from "_firebase";
import { AuthContext } from "features/Auth";

import Step1 from "./step1";
import Step2 from "./step2";

import classes from "./styles.module.scss";

import VoltaLogo from "assets/images/logo-color.svg";

export default ({ signUpWithEmailAndPassword, error, createUser }) => {
    const { setUser: setAuthUser } = useContext(AuthContext);
    const [step, setStep] = useState(1);
    const [processing, toggleProcessing] = useState(false);
    const [resuming, setResuming] = useState(true);
    const [user, setUser] = useState(null);
    const [registrationDone, setRegistrationDone] = useState(false);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            const currentUser = auth.currentUser;
            if (currentUser) {
                try {
                    const userData = await getUser(currentUser.uid);
                    if (!cancelled && userData?.registrationComplete === false) {
                        setUser(currentUser);
                        setStep(2);
                        mixpanel.track("Sign Up Step 2", {
                            UserId: currentUser.uid,
                            Resumed: true,
                        });
                    }
                } catch (error) {
                    console.error("Error checking incomplete registration", error);
                }
            }
            if (!cancelled) setResuming(false);
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    const handleCreateUser = async (event, regForm) => {
        event.preventDefault();
        toggleProcessing(true);
        const {
            email: { value: email },
            password: { value: password },
        } = regForm;

        if (!email || !password) {
            toggleProcessing(false);
            return;
        }

        const {
            error = null,
            canMoveToNextStep = false,
            user = null,
        } = await signUpWithEmailAndPassword(email, password);

        if (error) {
            toggleProcessing(false);
            return;
        }

        setUser(user);

        if (canMoveToNextStep) {
            mixpanel.track("Sign Up Step 1", {
                UserId: user?.uid,
                Email: email,
            });
            setStep(2);
            mixpanel.track("Sign Up Step 2", {
                UserId: user?.uid,
                Resumed: false,
            });
        }

        toggleProcessing(false);
    };

    const handleUserDetails = async (event, accountDetails, isReqTeamToCreate) => {
        toggleProcessing(true);
        const newAccountDetails = {};

        Object.entries(accountDetails).forEach(([key, { value }]) => {
            if (key === "profession") {
                newAccountDetails["isRea"] = value.includes("registeredEnergyAdvisor");
            }
            newAccountDetails[key] = value;
        });

        const result = await createUser(event, user, newAccountDetails, isReqTeamToCreate);

        if (result?.success) {
            mixpanel.track("Sign Up Complete", {
                UserId: user?.uid,
                ReqTeam: Boolean(isReqTeamToCreate),
                IsRea: Boolean(newAccountDetails.isRea),
                Profession: newAccountDetails.profession,
            });
            setAuthUser(auth.currentUser);
            localStorage.setItem("wasLoggedIn", "true");
            setRegistrationDone(true);
        }

        toggleProcessing(false);
    };

    if (registrationDone) {
        return <Redirect to="/dashboard" />;
    }

    if (resuming) {
        return null;
    }

    return (
        <div className={classes.authWrapper}>
            <div className={classes.stepsWrapper}>
                <img
                    src={VoltaLogo}
                    style={{ height: "30px", alignSelf: "flex-start" }}
                    alt="Volta Snap logo in colour"
                />
                {step === 1 && <Step1 createUser={handleCreateUser} error={error} processing={processing} />}
                {step === 2 && <Step2 handleUserDetails={handleUserDetails} processing={processing} />}
            </div>
        </div>
    );
};
